// import "@babel/polyfill"
// import "fetch-ie8"

import 'element-ui/lib/theme-chalk/index.css'

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import "./init/use.js";
import "./init/global.js";
import "./utils/directives.js"

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
